import z from 'zod';

export const calendarDateTimeSchema = z.string().regex(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/);

export const calendarDateTimeRange = z.object({
  start: calendarDateTimeSchema,
  end: calendarDateTimeSchema,
});

export type CalendarDateTimeRange = z.infer<typeof calendarDateTimeRange>;
